import { Card } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const COLORS = {
  positive: "#52c41a",
  negative: "#ff4d4f",
};

function ProfitByBusChart({ data, loading }) {
  if (!data || data.length === 0) {
    return (
      <Card title="Top 10 Viajes por Ganancia" loading={loading}>
        <div className="h-64 flex items-center justify-center text-gray-400">
          No hay datos para mostrar
        </div>
      </Card>
    );
  }

  const formatCurrency = (value) => {
    return `$${value.toLocaleString()}`;
  };

  // Tomar los top 10 viajes por ganancia (absoluta)
  const topTrips = [...data]
    .sort((a, b) => Math.abs(b.profit) - Math.abs(a.profit))
    .slice(0, 10)
    .map(trip => ({
      ...trip,
      label: `${trip.excursion_name || 'Sin excursión'} - ${trip.date || ''}`,
    }));

  return (
    <Card title="Top 10 Viajes por Ganancia" loading={loading}>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={topTrips}
          layout="vertical"
          margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" tickFormatter={formatCurrency} />
          <YAxis type="category" dataKey="label" width={90} tick={{ fontSize: 11 }} />
          <Tooltip
            formatter={(value) => [formatCurrency(value), "Ganancia"]}
            labelFormatter={(label) => label}
          />
          <Bar dataKey="profit" name="Ganancia">
            {topTrips.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.profit >= 0 ? COLORS.positive : COLORS.negative}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}

export default ProfitByBusChart;
